export default "__VITE_ASSET__cTfDvbCPSAVc$Aoh4PvVSw__"